module.exports = __webpack_public_path__ + "static/media/not-found.ee4d9295.gif";